var MenuItemModel = /** @class */ (function () {
    function MenuItemModel() {
    }
    return MenuItemModel;
}());
export { MenuItemModel };
